/** MSP-level manage-subscriptions path. Always use this for Stripe success/cancel URLs. */
export const MSP_MANAGE_SUBSCRIPTIONS_PATH = '/mspHome/administration/manage-subscriptions';

/** True when `pathname` is Plan & Billing (Manage Subscriptions), MSP or org-scoped. */
export function isManageSubscriptionsPath(pathname) {
  if (!pathname || typeof pathname !== 'string') return false;
  if (pathname === MSP_MANAGE_SUBSCRIPTIONS_PATH) return true;
  return /^\/organization\/[^/]+\/administration\/manage-subscriptions$/.test(pathname);
}

/**
 * Resolves the Plan & Billing (Manage Subscriptions) route.
 * Always returns the MSP-level URL — there is no org-scoped manage-subscriptions route in MainRoutes,
 * and Stripe success/cancel URLs use the same MSP path (see subscriptionRedirect.js).
 */
export function getManageSubscriptionsPath() {
  return MSP_MANAGE_SUBSCRIPTIONS_PATH;
}

/**
 * Schedule hub (reboot schedules grid) after saving a reboot policy from the device reboot drawer.
 * Matches org vs location routes in `MainRoutes` / menu (`/organization/:orgName/scheduled` vs `/scheduled`).
 *
 * @param {'parOrg' | 'locationLevel' | 'deviceGroupLevel' | string} callingFrom - `DevicePage` `callingFrom` prop
 * @returns {string | null} path to `navigate`, or null if org name cannot be resolved for org context
 */
export function getScheduledHubPathForDeviceContext(callingFrom) {
  if (callingFrom === 'locationLevel') {
    return '/scheduled';
  }
  if (callingFrom !== 'parOrg' && callingFrom !== 'deviceGroupLevel') {
    return null;
  }
  if (typeof window === 'undefined') {
    return null;
  }
  const path = window.location.pathname;
  const parts = path.split('/');
  const orgIdx = parts.indexOf('organization');
  if (orgIdx !== -1 && parts.length > orgIdx + 1) {
    let orgName = parts[orgIdx + 1];
    try {
      orgName = decodeURIComponent(orgName);
    } catch (e) {
      // keep raw segment
    }
    return `/organization/${encodeURIComponent(orgName)}/scheduled`;
  }
  try {
    const saved = typeof localStorage !== 'undefined' ? localStorage.getItem('savedOrgName') : null;
    if (saved) {
      return `/organization/${encodeURIComponent(saved)}/scheduled`;
    }
  } catch (e) {
    // ignore
  }
  return null;
}
